<template>
    <div class="insurance-target-section">
        <ul class="insurance-target-section__list">
            <li class="insurance-target-section__item"
                v-for="card in insuranceTargetCards" 
                :key="card.iconName" >
                <InsuranceTargetCard :text-html="card.text" :icon-name="card.iconName" />
            </li>
        </ul>
    </div>
</template>

<script>
import InsuranceTargetCard from '@/components/ui/InsuranceTargetCard';
export default {
    name: 'InsuranceTargets',
    components: {
        InsuranceTargetCard
    },
    data() {
        return {
            insuranceTargetCards: [
                {
                    text: '<strong>Недвижимое имущество:</strong> Конструктивные элементы квартиры, апартаментов, загородного дома или таунхауса будут застрахованы от ущерба нанесенного в результате взрыва газа или возгорания, затопления водой, падения воздушных судов или их обломков на дом, природных катаклизмов, противоправных деяний посторонних.',
                    iconName: 'building-white'
                },
                {
                    text: '<strong>Жизнь и здоровье заемщика:</strong> Страховым случаем в рамках полиса страхования жизни и здоровья заемщика считается наступление смерти застрахованного человека, вызванное болезнью или несчастным случаем, а также установление инвалидности первой или второй группы, которая возникла в результате несчастного случая или заболевания.',
                    iconName: 'triangle-white'
                },
                {
                    text: '<strong>Титул:</strong> По программе страхования титула страховым событием считается полная или частичная утрата страхователем (залогодателем) права собственности на заложенное имущество. Выплата страхового возмещения производится на основании вступившего в законную силу судебного решения, признающего сделку по передаче прав на недвижимость недействительной.',
                    iconName: 'judge-gavel-white'
                },
                {
                    text: '<strong>Ответственность перед соседями:</strong> Возмещение ущерба, нанесенного вами имуществу соседей.',
                    iconName: 'monitor-white'
                },

            ]
        }
    }
}
</script>

<style scoped lang="scss">
.insurance-target-section {
    &__list {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;

        row-gap: rem($gap-medium);

        @media #{$screen-small} {
            flex-direction: column;
        }
    }

    &__item {
        &:nth-child(1), &:nth-child(2) {
            @include flex-width-two-in-row($gap-medium);
        }



        &:nth-child(3) {
            width: calc(65.5% - $gap-medium / 2);

            @media #{$screen-big} {
                width: calc(65% - $gap-medium / 2);
            }
        }
        
        &:nth-child(4) {
            width: calc(34.5% - $gap-medium / 2);

            @media #{$screen-big} {
                width: calc(35% - $gap-medium / 2);
            }
        }

        @media #{$screen-small} {
            width: 100% !important;
        }
    }

    &__comment {
        @include text-average($font-weight-medium);

        width: 50%;
        margin-top: rem($gap-medium);

        color: $color-text-weekened-low;

        
        font-size: rem($font-size-normal);
        

        @media #{$screen-medium} {
            font-size: rem($font-size-small);

            width: 70%;
        }

        @media #{$screen-small} {
            width: 100%;
        }
        
        &-link {
            color: $primary-weekened;
            text-decoration: underline;
            text-underline-offset: rem(4px);
        }
    }
}
</style>